import { Injectable } from '@angular/core';
import { SearchResultFactoryService } from '@df/search/search-result-factory.service';
import { Search } from '@df/search/search.interfaces';
import { SearchResultDecorator } from './search-result.decorator';

@Injectable({
    providedIn: 'root'
})
export class SearchResultFactoryServiceDecorator extends SearchResultFactoryService {
    override create(term: string, data: Search.IResult, options: Search.ISearchResultOptions) {
        return new SearchResultDecorator(term, data, options);
    }
}
